import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { FeedsService } from "../../../service/feeds/feeds.service";
import { Notifications, NotificationSortConfiguration } from "../feeds.config";
import { FilterFieldsConfig } from "./notification.config";
import { WrapperService } from "../../../service/wrapper/wrapper.service";
import { SdsFormlyTypes } from "@gsa-sam/sam-formly";
import { AuthService } from "@gsa-sam/shared";

@Component({
  selector: 'sam-frontend-admin-notification-feeds',
  templateUrl: './notification-feeds.component.html',
  styleUrls: ['./notification-feeds.component.css'],
})
export class NotificationFeedsComponent implements OnInit, AfterViewChecked {
  fields: FormlyFieldConfig[] = FilterFieldsConfig;
  filterObj: any = {};
  isMobileResolution: boolean;
  page = {
    pageNumber: 1,
    pageSize: 25,
    totalPages: 0,
  };
  cookie: any;
  top = { id: 'top' };
  bottom = { id: 'bottom' };
  initLoad: boolean;
  totalRecords: number;
  totalPages: any = 0;
  loading = new Array(25);
  pageNum: number = 1;
  notificationData: Notifications[] = [];
  SortConfiguration = NotificationSortConfiguration;
  selectedSort: any = this.SortConfiguration[0];
  defaultFeedTypes: any;
  user: any;
  typeID: any;
  notificationMap: any;
  options: any = [];

  constructor(
    private feedsService: FeedsService,
    private changeDetectionRef: ChangeDetectorRef,
    private wrapperService: WrapperService,
    
    private authXService: AuthService
  ) {}

  ngOnInit(): void {
    // is cookie used here
    // this is the X-Auth was this.iamService.auth.token
    this.cookie = this.authXService.authToken();

    this.getUserInfo();
    this.toggleResolution();
  }

  ngAfterViewChecked() {
    this.changeDetectionRef.detectChanges();
  }

  /**
   * @name getUserInfo
   * @type method - called in ngOnInit
   * @description - sets the types based on available options
   */
  public getUserInfo() {
    this.wrapperService.call({ name: 'session' }).subscribe((data) => {
      if (data) {
        this.user = data;
        this.defaultFeedTypes = this.user?.isGov ? '3,4,6' : '3,4,6,7';
      }
      this.loadNotificationData();
    });
  }

  /**
   * @name onResize
   * @type Event - triggered by when the document view (window) has been resized
   * @param  - add event listener method allows to handle event of the host element in the directive class
   */
  @HostListener('window:resize')
  onResize() {
    this.toggleResolution();
  }

  /**
   * @name toggleResolution
   * @description Sets isMobileResolution flag on page load and resize.
   *              Called by ngInit() and HostListener(window:resize)
   */
  toggleResolution(): void {
    this.isMobileResolution = window.innerWidth <= 639;
  }

  /**
   * @name redirectToView
   * @type function
   * @param url - url of link to open
   * @description opens new tab to the URL supplied
   */
  public redirectToView(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * @name onPageNumChange
   * @description triggered by Pagination component's pageChange event
   * @param event - Event that contains the following
   *                totalPages: total number of pages to display
   *                pageNumber: the current page number
   *                pageSize: the amount of records to display (handled by pagination dropdown)
   */
  onPageNumChange(event: any) {
    this.page.pageSize = event.pageSize;
    this.pageNum = event.pageNumber;
    this.loadNotificationData();
  }

  /**
   * @name loadNotificationData
   * @description Pulls and loads the notification data
   */
  loadNotificationData(): void {
    this.typeID = this.filterObj.feedTypeId
      ? this.filterObj.feedTypeId
      : this.defaultFeedTypes;

    this.initLoad = true;
    this.feedsService
      .getNotificationFeeds(
        this.typeID,
        this.selectedSort.field,
        this.selectedSort.direction,
        this.page.pageSize,
        this.pageNum,
        this.filterObj
      )
      .subscribe({
        next: (data) => {
          if (data && data.notificationCount && data.notificationFeeds) {
            this.notificationData = data.notificationFeeds;
            this.notificationMap = data?.notificationMap;
            this.totalRecords = data.notificationCount;
            this.page.totalPages = Math.ceil(
              this.totalRecords / this.page.pageSize
            );
          } else {
            this.notificationData = [];
            this.totalRecords = 0;
            this.notificationMap = {};
          }
          this.options = [];
          this.updateFilterListOptions();
          this.initLoad = false;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  /**
   * @name updateFilterListOptions
   * @type method - called after loading
   * @description - sets the types based on available options
   */
  updateFilterListOptions() {
    for (let key in this.notificationMap) {
      if (+key && this.notificationMap[key] > 0) {
        this.options.push(key);
      }
    }

    if (!this.filterObj.feedTypeId && !this.filterObj.domains)
      localStorage.setItem('typesFilter', JSON.stringify(this.options));
    this.options = JSON.parse(localStorage.getItem('typesFilter'));

    this.fields.forEach((ff) => {
      if (ff.key === 'types') {
        const field = ff.fieldGroup.find((x) => x.key === 'typesCheckbox');
        const propOptions = field.props?.options;
        if (propOptions) field.props.options = this.getFieldData(this.options);

        if (!this.options?.length) {
          field.type = SdsFormlyTypes.READONLY;
          field.props.readonlyTemplate = (field) => {
            return `
              <p>No Notifications</p>
            `;
          };
        }
      }
    });
  }

  /**
   * @name getFieldData
   * @type method - called in getFieldData
   * @description - pushes value/labels into FieldGroup based
   * on user's notification types
   */
  getFieldData(data) {
    const options = [];
    data.forEach((v) => {
      switch (+v) {
        case 3:
          options.push({
            value: '3',
            label: 'Followed Records',
          });
          break;
        case 6:
          options.push({
            value: '6',
            label: 'Assign Role',
          });
          break;
        case 7:
          if (!this.user?.isGov) {
            options.push({
              value: '7',
              label: 'Entity Registration Updates',
            });
          }
          break;
      }
    });
    return options;
  }

  /**
   * @name onFilterChange
   * @type Event - triggered by using filter.
   * @param filterObj - contains domain and type search info needed for filter
   */
  onFilterChange(filterObj: any): void {
    this.filterObj = filterObj;
    this.pageNum = 0;
    this.page.pageNumber = 1;
    this.loadNotificationData();
  }
}
